var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuOrganize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_4380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7116 19.7117C21.3273 18.096 19.1844 13.3336 14.9254 9.07456C10.6663 4.81553 5.90396 2.67266 4.28829 4.28834C2.67261 5.90401 4.81548 10.6664 9.07452 14.9254C13.3335 19.1845 18.0959 21.3273 19.7116 19.7117Z",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9254 14.9254C19.1844 10.6664 21.3273 5.90401 19.7116 4.28834C18.0959 2.67267 13.3335 4.81554 9.07452 9.07457C4.81548 13.3336 2.67261 18.096 4.28829 19.7117C5.90396 21.3273 10.6663 19.1845 14.9254 14.9254Z",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.125C12.6213 13.125 13.125 12.6213 13.125 12C13.125 11.3787 12.6213 10.875 12 10.875C11.3787 10.875 10.875 11.3787 10.875 12C10.875 12.6213 11.3787 13.125 12 13.125Z",
    fill: "var(--sidebar-text-color)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_4380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--sidebar-text-color)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuOrganize);
export default __webpack_public_path__ + "static/media/ic-menu-organize.faf74be261760030eb51c5447fb636b2.svg";
export { ForwardRef as ReactComponent };